/**
 * @generated SignedSource<<ff70a9438021df4c694a99fc1296759c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleListArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleDividerArticle" | "articleFooterArticle" | "articlePaginationCheckerArticle" | "articlePaginationNavigationHistoryArticle" | "articlePaywallCheckerContent" | "articleRecommendationArticle" | "articleRenderArticle" | "contextsArticleListContextProviderArticle" | "contextsContentReadMoreContextProviderContent" | "helpersCheckIsPostiesArticle" | "helpersCheckIsStyleArticle" | "topBannerContent">;
  readonly " $fragmentType": "articleListArticle";
};
export type articleListArticle$key = {
  readonly " $data"?: articleListArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleListArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleListArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topBannerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleDividerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleFooterArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaginationCheckerArticle"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "articlePaginationNavigationHistoryArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleRecommendationArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaywallCheckerContent"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "articleRenderArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPostiesArticle",
      "selections": (v2/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsStyleArticle",
      "selections": (v2/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contextsContentReadMoreContextProviderContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "contextsArticleListContextProviderArticle",
      "selections": (v1/*: any*/),
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "b984119fb0e4ebb188590fea04cd004e";

export default node;
